<!--<div class="form-group row">
  <label class="control-label col-4">{{'Ngày tạo' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <kendo-dateinput tabindex="1" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Người tạo' | translate}}</label>
  <div class="col-8">
    <input type="text" tabIndex="2" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
</div>-->






<div class="row form-group" *ngFor="let u of doituongSelect.ChiTiets">
  <label class="control-label col-6">{{u.Khoa | translate}}</label>
  <div class="col-6 required-field">
    <label>
      <input tabIndex="20" type="checkbox" [(ngModel)]="u.HienThi" />
       Tích là hiển thị
    </label>
  </div>
</div>







<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>
  <div class="">

    <button type="submit" (click)="ThucHien()" class="mb-1 mr-1 btn btn-primary">Lưu cấu hình</button>

    <!--<div class="btn-group mb-1 mr-1" dropdown>
      <button class="btn dropdown-toggle btn-success" type="button" dropdownToggle style="height:26px">
        <i class="fa fa-download"></i>
        Tiện ích
      </button>
      <div *dropdownMenu class="dropdown-menu" role="menu">
        <a class="dropdown-item" (click)="export('pdf')">Xem thông báo</a>
        <a class="dropdown-item" (click)="export('xlsx')">Xuất excel</a>
        <a class="dropdown-item" (click)="tuychinhmaubaocao()">Chỉnh sửa mẫu</a>
      </div>
    </div>-->
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát">Đóng lại</button>

    <!--<button type="submit" (click)="ThucHien()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại chốt buổi học</button>-->
  </div>

</div>

<!--<bs-modal #modaltuychinhmaubc class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chỉnh sửa mẫu cho thông báo học phí</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modaltuychinhmaubc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-quantri-tuychinhmaubcedit #dtsuamaubaocao></app-quantri-tuychinhmaubcedit>
  </bs-modal-body>
</bs-modal>-->

